import { sendPageEvent } from "../analytics";
import { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";

export function Analytics() {
  const [loaded, setLoaded] = useState(false);
  const intervalRef = useRef(null);

  // Only enable tracking in production
  if (!import.meta.env.PROD) return null;

  // We try to detect when the scripts are actually loaded AND parsed
  // That way we know when to sent out the first event
  useEffect(() => {
    intervalRef.current = setInterval(() => {
      if (window.digitalData) {
        setLoaded(true);
        clearInterval(intervalRef.current);
      }
    }, 100);
  }, []);

  useEffect(() => {
    if (loaded) sendPageEvent();
  }, [loaded]);

  return (
    <Helmet>
      <script
        src="https://t.vrt.be/latest/vrtebahelper.min.js"
        async
        defer
      ></script>
      <script src="https://t.vrt.be/latest/vrteba.min.js" async defer></script>
    </Helmet>
  );
}
